export default "__VITE_ASSET__DsxA9x6M__"